import { reactive } from 'vue'
import actions from '@/store/group/actions'
import state from '@/store/group/state'
import getters from '@/store/group/getters'

export const groupModule = {
    state: reactive(state),
    actions,
    getters,
}
